import styled from 'styled-components'
import { useLottie } from 'lottie-react'
import infiniteLoader from 'src/resources/lottie/infiniteLoading.json'
import { Colors } from 'src/resources/colors'
import { fontSizes } from 'src/resources/typography'
import { SpreadsheetIcon } from 'src/resources/elements/Icons'

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 150px;

  div:first-child,
  span {
    margin-bottom: 5px;
  }
`

const NameWrap = styled.span`
  color: ${Colors.textLogo};
  font-size: ${fontSizes.type18};
  font-weight: 600;
`

export const BrandedInfiniteLoader = ({ name }: { name: string }) => {
  const options = {
    animationData: infiniteLoader,
    loop: true,
    autoplay: true
  }

  const { View } = useLottie(options)
  return (
    <LoadingContainer>
      <div>
        <SpreadsheetIcon />
      </div>
      {View}
      <NameWrap>{name}</NameWrap>
    </LoadingContainer>
  )
}
